<template>
  <zpa-form ref="Form" :label-width="120" style="height: 800px !important;max-height: 800px !important;">
    <form-info v-if="data.id" :data="data" :canOperate="false" :checkPublic="true"/>
  </zpa-form>
</template>


<script>

import ccjtXmsbApplyInfoApi from '@/api/ccjt/ccjtXmsbApplyInfo'
import FormInfo from "@/modules/ccjt/ccjtXmsbApplyInfo/operators/components/FormInfo.vue";
export default {
  name: 'ZlxxDetailForWeb',
  components: {FormInfo},

  data() {
    return {
      data:{ }
    }
  },
  created() {

    if(this.$route.query.id){
      this.initData(this.$route.query.id)
    }
  },
  methods: {
    async initData(id) {

      const res = await ccjtXmsbApplyInfoApi.openDetail(id)
      res.attachfiles = JSON.parse(res.attachfiles);
      res.otherInfo = JSON.parse(res.otherInfo);
      res.contractInfo = JSON.parse(res.contractInfo);
      res.formInfo = JSON.parse(res.formInfo);
      this.data = res
    }
  },
}
</script>
